import {PmBarchartDataService,PmDatapointPropertyDetail} from 'core-dashboard'
import { Injectable } from '@angular/core';
import { DataProvider,ParameterService,Widget,DashboardConfigManager,AuthService,LogService,BarChartResponseObject  } from "core-dashboard";
import { HttpClient, HttpResponse } from '@angular/common/http';

//Todo- replace all if and else condition by using interfaces and base classes
//todo -Handle localization
@Injectable()
export class PmBarchartProvider implements DataProvider {

    widget: Widget;
    config: any;
    From: any = undefined;
    To: any = undefined;

    dpName: any = undefined;
    interval: any = undefined;
    duration: any = undefined;
    labelConfig: any = undefined;
    locale: any = "en-US";

    private bardata: BarChartResponseObject;

    constructor(private authService: AuthService,
        private parameterService: ParameterService,
        private http: HttpClient,
        private logger: LogService,
        private barchartDataService: PmBarchartDataService,
        private dashboardConfig: DashboardConfigManager) {
    }

    //this is to get reduced COV data if required
    getReducedCovData(tData:any){
        
    }
    getData(w: Widget) {

        this.widget = w;
        this.config = this.widget.getConfig();

        console.log(this.config);
        try {
            if (this.config == undefined) {
                this.logger.logWarning("PmBarchartProvider", " Config is missing in widget setup.");
                this.widget.Draw(null);
                return;
            }

            if (this.authService.HasValidSSO() && this.authService.HasValidToken() === false) {
                this.authService.LoginWithSSO().subscribe(
                    (response:HttpResponse<any>) => {
                        if (response) {
                            this.getBarchartData();
                        }
                    }, error => {

                        //this code will get executed when base URL path is inccorrect
                        this.logger.logWarning("PmBarchartProvider", "PmBarchartProvider can not login to desigo cc.");
                        this.widget.Draw(null);
                    });
            }
            else if (this.authService.HasValidToken()) {
                this.getBarchartData();
            } else {
                this.logger.logWarning("PmBarchartProvider", "PmBarchartProvider can not login to desigo cc.");
                this.widget.Draw(null);
            }
        }
        catch (error) {
            this.logger.logError('PmBarchartProvider', "Error while fetching data. Error:" + error);
            this.widget.Draw(null);
        }
    }

    // this will zoom the widget
    zoom(zoomFrom: any, zoomTo: any) {
    }

    private getBarchartData() {
        try {
            var thisProvider = this;
            this.readConfig();
            let currentDate: Date = new Date();
            this.barchartDataService.getBarchartData(this.dpName, this.duration, this.interval, currentDate,this.locale).subscribe(barChartResponse => {
                if (barChartResponse !== null) {
                    let label = thisProvider.getDpLabelBasedonConfig(barChartResponse.DpPropertyDetail, thisProvider.labelConfig);
                    let unit = barChartResponse.DpPropertyDetail.Unit; 
                    let barResponseArrayCollection: any = [];
                    let resolution = barChartResponse.DpPropertyDetail.Resolution;
                    barChartResponse.ResponseArrayCollection.forEach(elements => {
                        elements.forEach(element => {
                            barResponseArrayCollection.push({ key: element.key, value: parseFloat(element.value.toFixed(resolution)), Unit: unit, Resolution: resolution });
                        });
                    });
                    let bardata: BarChartResponseObject = { DataPointName: label, PropertyName: barChartResponse.DpPropertyDetail.PropertyName, xAxisLabel: thisProvider.labelConfig.xAxisLabel, yAxisLabel: thisProvider.labelConfig.yAxisLabel, ResponseArrayCollection: [barResponseArrayCollection] }
                    thisProvider.widget.Draw(bardata);
                }
            });
        }
        catch (error) {
            this.logger.logError('PmComparableBarchartProvider', "Error:" + error);
        }
    }

    private getDpLabelBasedonConfig(propertyDetail: PmDatapointPropertyDetail, labelConfig: any): string {
        let label: string = ""
        if (!labelConfig.LocalizedDescription) {
            let showDeviceDescription = labelConfig && labelConfig.DisplayDeviceDescriptor ? labelConfig.DisplayDeviceDescriptor : undefined;
            let showPropertyDescriptor = labelConfig && labelConfig.DisplayPropertyDescriptor ? labelConfig.DisplayPropertyDescriptor : showDeviceDescription ? undefined : true;

            if (showDeviceDescription) {
                label = propertyDetail.DataPointDescription;
            }
            if (showPropertyDescriptor) {
                label = propertyDetail.PropertyDescription;
            }
            if (showDeviceDescription && showPropertyDescriptor) {
                label = propertyDetail.PropertyDescription + " [" + propertyDetail.DataPointDescription + "]"
            }
        }
        else {
            label = labelConfig.LocalizedDescription
        }
        return label;
    }

    private processError(error: any) {
        let errMsg: any = error.message || "Server error";
        console.log("go error: " + error);
        this.logger.logError("PmComparableBarchartProvider", errMsg);
        if (this.widget)
            this.widget.Draw(null);
        //return Observable.throw(errMsg);
    }

    //#region Private Methods
    private readConfig(): void {
        if (this.config.dpName) {
            this.dpName = this.config.dpName;
        }
        else
            this.widget.Draw(null);

        if (this.config.Duration) {
            this.duration = this.config.Duration;
        }
        if (this.config.Interval) {
            this.interval = this.config.Interval;
        }
        if (this.config.LabelConfiguration) {
            this.labelConfig = this.config.LabelConfiguration;
        }
        if (this.config.Locale) {
            this.locale = this.config.Locale;
        }
    }

    //#endregion

    dispose(): void {

    }
}